var map = {
	"./BEc_graph.svg": 189,
	"./BEn_graph.svg": 9596,
	"./BM_graph.svg": 7792,
	"./C_graph.svg": 1676,
	"./EcEn_graph.svg": 9042,
	"./EcM_graph.svg": 6798,
	"./En-Ec_graph.svg": 1329,
	"./EnEc_graph.svg": 382,
	"./EnM_graph.svg": 9309,
	"./M-Ec_graph.svg": 5189,
	"./M-En_graph.svg": 8551,
	"./MEc_graph.svg": 9154,
	"./MEn_graph.svg": 6683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 876;